import React from 'react';
import { ManageListingsContextProvider } from './ManageListingsContext';
import ManageListingsLayout from './ManageListingsLayout';

/**
 * The page to wrap the Context Provider around the Manage Listings page.
 */
const ManageListings: React.FC = () => (
  <ManageListingsContextProvider>
    <ManageListingsLayout />
  </ManageListingsContextProvider>
);

export default ManageListings;
